$('.hpe-header__search-button').click(function () {
  $('.hpe-header__search').removeClass('hpe-header__search--active');
});

$('.hpe-nav__search').click(function () {
  $('.hpe-header__search').toggleClass('hpe-header__search--active');
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/header-search.js